import { z } from 'zod'
import { oc } from '@orpc/contract'

export const bridgeProviderOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  npi: z.string(),
  /** Bridge's credential type: `MD`, `NP`, `PA`, `LCSW`, … Passed through, not enumerated. */
  type: z.string(),
})

/**
 * The organization's providers on Bridge's side, for the super-admin picker.
 *
 * Bridge onboards providers itself ("through coordination with Bridge"), so this list is
 * authoritative and read-only to us — the super admin picks from it rather than typing an
 * id, which is the whole reason this endpoint exists.
 *
 * An organization with no Bridge key reports `configured: false` with an empty list rather
 * than failing: this feeds a dropdown, and "save the key first" is a state to render, not
 * an error to raise.
 */
export const listOrganizationBridgeProviders = oc
  .route({ method: 'GET', path: '/v2/super/organizations/{organizationId}/bridge-providers' })
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(
    z.object({
      configured: z.boolean(),
      providers: z.array(bridgeProviderOptionSchema),
    }),
  )
